module.exports = __webpack_public_path__ + "static/media/active-goal-side.3b814455.png";